import { Project } from '@ih/app/shared/apis/interfaces';

export class SetProjects {
  public static readonly type = '[Organisation/Projects/List] SetProjects';
  constructor(public readonly projects: Project[]) {}
}
